/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import { useMediaQuery, useTheme } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { v4 } from "uuid";
import { Grid, Typography, Card, Box } from "@/components/core";
import { Arrow } from "./arrow";

export function Carousel({ slides }: any) {
  const theme = useTheme();
  const mobileMediaQuery = theme.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  const settings = {
    dots: !!isMobileDevice,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: (
      <Arrow
        icon={<ArrowBackIosIcon />}
        sx={{
          left: "-12px",
        }}
      />
    ),
    nextArrow: (
      <Arrow
        icon={<ArrowForwardIosIcon />}
        sx={{
          right: "-12px",
        }}
      />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box sx={{ pl: 1 }}>
      <Slider {...settings}>
        {slides.map((slide: any) => (
          <Card key={v4()} sx={{ p: 2, mx: 1 }}>
            <Grid>
              <Grid.Item xs={6}>
                <img
                  src={slide.imageUrl}
                  alt={slide.description}
                  style={{ width: "90%", height: "100px" }}
                />
              </Grid.Item>
              <Grid.Item xs={6}>
                <Typography bold>{slide.description}</Typography>
              </Grid.Item>
            </Grid>
          </Card>
        ))}
      </Slider>
    </Box>
  );
}

Carousel.propTypes = {
  slides: PropTypes.any,
};
